import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import LeonAvatar from './LeonAvatar';

export default function LeonMascot({ message, showBubble = false }) {
  const [isOpen, setIsOpen] = useState(showBubble);

  return (
    <div className="fixed bottom-8 right-8 z-40 hidden md:flex flex-col items-end gap-4">
      {/* Speech Bubble */}
      <AnimatePresence mode="wait">
        {isOpen && message && (
          <motion.div
            key="speech-bubble"
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.9 }}
            className="max-w-xs bg-zinc-900/95 backdrop-blur-xl border border-gold-500/30 rounded-2xl p-4 shadow-2xl relative"
          >
            <button
              onClick={() => setIsOpen(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-zinc-800 rounded-full flex items-center justify-center text-zinc-400 hover:text-white transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
            <div className="flex items-start gap-3">
              <LeonAvatar className="w-10 h-10 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-gold-500 mb-1">Léon, votre assistant</p>
                <p className="text-sm text-zinc-300 leading-relaxed">{message}</p>
              </div>
            </div>
            {/* Arrow */}
            <div className="absolute -bottom-2 right-8 w-4 h-4 bg-zinc-900/95 border-r border-b border-gold-500/30 transform rotate-45"></div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Mascot Avatar */}
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="relative group"
        data-testid="leon-mascot"
      >
        <div className="w-20 h-20 rounded-full p-0.5 shadow-lg shadow-gold-500/30">
          <LeonAvatar className="w-full h-full drop-shadow-2xl" />
        </div>
        {/* Notification dot */}
        {!isOpen && message && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-gold-500 rounded-full flex items-center justify-center animate-pulse">
            <MessageCircle className="w-3 h-3 text-black" />
          </span>
        )}
        {/* Hover glow */}
        <div className="absolute inset-0 rounded-full bg-gold-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity -z-10"></div>
      </motion.button>
    </div>
  );
}
